/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Fonts} from '../../Themes'
export default StyleSheet.create({
  container: {
    flex: 1
  },
  statisticInfoContainer: {
    flexDirection: 'row',
   justifyContent: 'space-between'
  },
  item : {
    justifyContent: 'center',
    alignItems: 'center'
 
  },
  statisticItem: {
   width: 30,
    height: 30,
    alignSelf: 'center',
    backgroundColor: '#FFFFFF'
  },
  fontSize: {
    fontSize: 13,
    color:Fonts.style.color.disable
   
  },
  smallFontSize: {
    fontSize: 14
  },
  plusIcon: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    backgroundColor: '#d5d5d5',
    height: 25,
    width: 25,
    justifyContent: 'center',
    alignItems: 'center'
  },
  textInputLink: {
    height: 35,
    borderColor: '#d5d5d5',
    borderRadius: 5,
    borderWidth: 1,
    flex: 1
  },
  tconContainer: {
  marginLeft: 25,
    height: 30,
    width: 30,
    borderColor: '#8692b7',
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  tconBorder: {
    width: 30,
    height: 30
  }
})
